<template>
  <Popup ref="popup" :isShowClose="false" :is-show="isShowPopup" @closed="closedPopup" title="Thông báo" height="200">
      <template slot="body">
        <div class="flex flex-col justify-between items-center">
            <!-- <font-awesome-icon class="text-[40px]" :icon="['fas', 'exclamation-circle']" size="lg" style="color: #ff0000;" /> -->
            <div class="text-center">Tài khoản của bạn hiện chưa được kích hoạt. Hãy liên hệ bộ phận IT để được hỗ trợ.</div>
        </div>
      </template>
      <template slot="footer">
        <div>
            <el-button type="danger" @click="logout">Đăng xuất</el-button>
        </div>
      </template>
    </Popup>
</template>

<script>
import Popup from '../component/common/Popup.vue';
import { removeFromStorage } from "@/utils/storage";
export default {
    components: { 
        Popup 
    },
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isShowPopup: false
        }
    },
    mounted() {
        if(this.isShow) {
            this.isShowPopup = true
        }
    },
    methods: {
        closedPopup() {
            this.isShowPopup = false
        },

        logout() {
            removeFromStorage("uToken")
            this.$app.islogin = false
        }
    }
}
</script>

<style lang="scss" scoped>
.el-button {
    background-color: red;
}
</style>